import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import gql from 'graphql-tag'
import * as OSS from 'ali-oss'
import moment from 'moment'

import { STSCredential } from '@/interfaces/sts-credential'
import { TypedGqlError } from '@/interfaces/error'
import { showErrors } from '@/utils/snack'

@Component
export default class FileHandler extends Vue {
  stsCredential: STSCredential | null = null
  fileToUpload: File | null = null
  fileUploaded: any = null
  acceptFileTypes = `
    application/pdf, image/*
  `

  ossPrefix = ''

  ossPath = ''

  // 获取oss证书 request
  async getOSSCredentials () {
    try {
      const result = await this.$apollo.query({
        query: gql`
          query {
            getOssCredentials {
              accessKeyId
              accessKeySecret
              stsToken
              expiration
              bucket
              region
            }
          }
        `
      })
      this.stsCredential = result.data.getOssCredentials
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async uploadFileToOSS (coverImages: string[]) {
    if (!this.stsCredential || !this.fileToUpload) return
    const { accessKeyId, accessKeySecret, stsToken, bucket, region } = this.stsCredential
    const { fileToUpload } = this
    // @ts-ignore
    const client = new OSS({
      region: region,
      accessKeyId: accessKeyId,
      accessKeySecret: accessKeySecret,
      bucket: bucket,
      stsToken: stsToken
    })
    // fileToUpload：本地文件
    // 阿里云文件存储路径：oss
    const path = this.ossPath || this.ossPrefix + moment().format('YYYY/MM/DD') + moment().unix() + `_${fileToUpload.name}`
    const result = await client.put(path, fileToUpload)
    const ossUrl = (process.env.VUE_APP_OSS_URL?.split('//')[1] ?? '').replace(/\/+$/, '')
    const domainUrl = (process.env.VUE_APP_DOMAIN?.split('//')[1] ?? '').replace(/\/+$/, '')
    const url = this.$R.replace(ossUrl, domainUrl, result.url)
    this.fileToUpload = null
    // 返回新的coverImages
    this.fileUploaded = [url, ...coverImages]
    return this.fileUploaded
  }

  // 阿里云删除对象时是删除上传的地址
  async deleteFileFromOSS (url: string) {
    if (!this.checkCredentialValid()) {
      await this.getOSSCredentials()
    }

    if (!this.stsCredential) return
    const { accessKeyId, accessKeySecret, stsToken, bucket, region } = this.stsCredential
    // @ts-ignore
    const client = new OSS({
      region: region,
      accessKeyId: accessKeyId,
      accessKeySecret: accessKeySecret,
      bucket: bucket,
      stsToken: stsToken
    })
    // fileName： goods_covers/2022/05/051651732669_27876625-1_u_3.jpg
    const fileName = this.$R.replace(process.env.VUE_APP_DOMAIN + '/', '', url)
    await client.delete(fileName)
  }

  checkCredentialValid () {
    if (!this.stsCredential) return false
    return moment().isBefore(moment.utc(this.stsCredential.expiration).local())
  }
}
